module.exports = __webpack_public_path__ + "img/tuiguang3-2-3.a14c863d.png";